import React from 'react';
import { motion } from 'framer-motion';
import { OnboardingV2State } from '../../../../store/onboardingV2/types.ts';
import { OnboardingStep, getAllSteps } from '../../../../utils/onboardingV2/conversationalOnboardingSteps.ts';
import styles from './CompleteActions.module.scss';

interface CompleteActionsProps {
  state: OnboardingV2State;
  onAction: (action: string, data?: any) => void;
  onNavigateToStep?: (step: OnboardingStep) => void;
}

const CompleteActions: React.FC<CompleteActionsProps> = ({ state, onAction, onNavigateToStep }) => {
  const completeSteps = getAllSteps(state).filter((step) => step.id !== 'summary');

  return (
    <motion.div
      className={styles.interactiveContainer}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
    >
      <div className={styles.completeActions}>
        <div className={styles.completeActionsHeader}>
          Podés revisar o cambiar pasos
        </div>
        <div className={styles.completeStepsList}>
          {completeSteps.map((step) => (
            <motion.button
              key={step.id}
              className={styles.completeStepButton}
              onClick={() => onNavigateToStep?.(step.id)}
              whileHover={step.canNavigate ? { scale: 1.02 } : {}}
              whileTap={step.canNavigate ? { scale: 0.98 } : {}}
              type="button"
              disabled={!step.canNavigate}
            >
              {step.label}
            </motion.button>
          ))}
        </div>
        <motion.button
          className={styles.completeButton}
          onClick={() => onAction('finishOnboarding')}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          type="button"
        >
          Finalizar onboarding
        </motion.button>
      </div>
    </motion.div>
  );
};

export default CompleteActions;
